import { css } from "@emotion/core";

import { color, fontSizes } from "../../../theme/Theme";

export const billsCardStyles = css({
  ".ant-btn-primary[disabled]": {
    color: color.placeholder,
    background: color.disabledBackground,
    border: color.placeholder,
    opacity: 1
  },
  ".metadata-label": {
    fontSize: fontSizes.title
  },
  ".bills-list": {
    boxShadow: "none",
    ".ant-table-thead > tr > th": {
      fontSize: fontSizes.label
    },
    ".ant-table-thead > tr > th, .ant-table-tbody > tr > td": {
      padding: "0.5rem 1rem",
      overflowWrap: "normal"
    },
    ".ant-table, .ant-btn": {
      fontSize: fontSizes.label
    },
    ".pending,.rejected,.approved,.paid": {
      width: "3.5rem"
    }
  },
  ".disabled-table": {
    ".ant-table-thead > tr > th": {
      backgroundColor: color.disabledBackground,
      color: color.placeholder
    }
  }
});

export const billsMetaDataStyle = (circleColor: string) =>
  css({
    background: circleColor,
    borderRadius: "50%",
    fontSize: fontSizes.h3Size,
    color: color.darkGrey,
    height: "3.5rem",
    width: "3.5rem"
  });
